import * as React from "react";
import { Context } from "./_context";
export const DowntrendIcon = ({ size = 16, variant = "inherit", ...rest }) => {
  const { variants } = React.useContext(Context);
  const color = variants[variant] || "#F0F";
  const props = { "aria-hidden": true, style: { color }, ...rest };
  const iconset = {};
  iconset[16] = /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11.75 10.69V5h1.5v7.5a.75.75 0 0 1-.75.75H5v-1.5h5.69L2.97 4.03l1.06-1.06 7.72 7.72Z", fill: "currentColor" }));
  return iconset[size];
};
DowntrendIcon.iconId = "3ZG16R";
